import './components/btn-up.js';
